import * as React from 'react';
import { api } from 'services';
import type { CreateServiceOrderTaskPayload } from 'contracts/service-orders';

export const useCreateTask = () => {
  const createTask = React.useCallback(
    async (data: CreateServiceOrderTaskPayload) => {
      await api.post('/inventory/service-order-tasks', data);
    },
    []
  );

  return {
    createTask,
  };
};
